import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/shop/search/page.tsx");
